import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { CreateOrEditDeploymentFreeze } from "~/components/DeploymentFreezes/CreateOrEditDeploymentFreeze";
interface CreateProjectDeploymentFreezePageProps {
    project: ProjectResource;
    spaceId: string;
}
export function CreateProjectDeploymentFreezePage({ project }: CreateProjectDeploymentFreezePageProps) {
    return <CreateOrEditDeploymentFreeze create={true} project={project}/>;
}
